<script lang="ts">
  import Slider from "$lib/molecules/Slider.svelte";
  import type { CardSliderStoryblok } from "$types/components";
  import GridContainer from "$lib/molecules/GridContainer.svelte";
  import GridItem from "$lib/atoms/GridItem.svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import Section from "$lib/molecules/Section.svelte";
  import ButtonLink from "$lib/atoms/ButtonLink.svelte";

  export let blok: CardSliderStoryblok;

  const isCompact = blok?.layout === "compact";
</script>

<div class="max-w-[100vw] overflow-hidden">
  <Section
    class="card-slider overflow-visible {isCompact ? 'md:!pt-0' : ''}"
    {blok}
  >
    <GridContainer>
      {#if !isCompact}
        <GridItem col={12} colMd={9}>
          <div class="header section-header">
            <p class="eyebrow type:section-title">{blok.eyebrow}</p>
            <h2 class="type:h2">{blok.headline}</h2>
          </div>
        </GridItem>
      {/if}
      <GridItem col={12}>
        <div class="slider-wrapper">
          <Slider
            items={blok.slides}
            slidesPerView={1.5}
            slidesPerViewMd={2.8}
            spaceBetween={24}
            pagination={true}
            controls={isCompact ? "top" : "bottom"}
            headline={isCompact ? blok.headline : undefined}
            class={isCompact ? "layout-compact" : "layout-normal"}
          >
            <StoryblokComponent
              slot="slide"
              layout={blok.layout}
              blok={item}
              let:prop={item}
            />
            <div class="get-in-touch" slot="bottom">
              {#if !isCompact}
                {#if blok.cta?.[0]}
                  <ButtonLink blok={blok.cta[0]} />
                {/if}
                <p class="catch type:label">
                  Reach out to our sales team to get started with Zipline.
                </p>
              {/if}
            </div>
          </Slider>
        </div>
      </GridItem>
    </GridContainer>
  </Section>
</div>

<style lang="scss">
  .eyebrow {
    margin-bottom: em(24px, 14px);
  }

  .slider-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;

    @include breakpoint("small") {
      flex-direction: column;
    }
  }

  .get-in-touch {
    display: flex;
    align-items: center;

    .catch {
      margin-left: fluid(46px, 32px);
      max-width: em(164px, 12px);
      display: none;

      @include breakpoint("small") {
        display: block;
      }
    }
  }
</style>
